import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import useFormContext from "./useFormEventMltComplete";
import 'reactjs-popup/dist/index.css';
import ConfirmationModal from '../GetEventMarsComplete.jsx/ConfirmationModal';
import ConfirmationModalAccept from '../GetEventMarsComplete.jsx/ConfirmationModalAccept';
import ConfirmationModalTentative from '../GetEventMarsComplete.jsx/ConfirmationModalTentative';
import axios from 'axios';
import { PROCESS_MLT_INVITATION } from '../ApiDetails';
import { notifySuccess, notifyError } from '../../utilities/Notification.tsx';

export default function FooterMlt() {
    const { handleSendForValidation, handleDeleteDraft, handleSubmit, eventFormData } = useFormContext();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isAcceptModalOpen, setIsAcceptModalOpen] = useState(false);
    const [isTentativeModalOpen, setIsTentativeModalOpen] = useState(false);    

    const ProcessEventInvitation = async (status, comment) => {
        if (eventFormData.eventId === 0) {
            return;
        }

        // Prepare data for processing invitation
        const data = new FormData();
        data.append("status", status);
        data.append("comment", comment);

        // Call Process Invitation API
        await axios.post(`${PROCESS_MLT_INVITATION}/${eventFormData.eventId}`, data)
            .then(response => {
                if (response.data) {
                    notifySuccess(`${status}!`, 'If your plans change, please contact Admin');
                } else {
                    notifyError('Oops!', 'Something went wrong while processing invitation');
                }
            })
            .catch(error => {
                console.error("Error in processing invitation:", error);
                notifyError('Oops!', 'Something went wrong while processing invitation');
            });
    };

    //for decline invitation
    const handleRejectClick = () => {
        setIsModalOpen(true);
    };

    const handleSaveClick = (comment) => {
        ProcessEventInvitation("Declined", comment);
        setIsModalOpen(false);
    };

    const handleCancelClick = (e) => {
        e.preventDefault();
        setIsModalOpen(false);
    };

    const handleAcceptClick = () => {
        setIsAcceptModalOpen(true);
    };

    const handleAcceptSaveClick = (comment) => {
        ProcessEventInvitation("Confirmed", comment);
        setIsAcceptModalOpen(false);
    };

    const handleAcceptCancelClick = (e) => {
        e.preventDefault();
        setIsAcceptModalOpen(false);
    };

    const handleTentativeClick = () => {
        setIsTentativeModalOpen(true);
    };

    const handleTentativeSaveClick = (comment) => {
        ProcessEventInvitation("Tentative", comment);
        setIsTentativeModalOpen(false);
    };

    const handleTentativeCancelClick = (e) => {
        e.preventDefault();
        setIsTentativeModalOpen(false);
    };

    const navigate = useNavigate();

    return (
        <footer className="footer">
            <div className="container-fluid">
                <div className="row footerButtonsContainer">
                    <div className="col-md-4">
                        <button type="button" className="btn btn-outline-light left-button"
                            onClick={() => navigate(-1)}
                        >
                            Back
                        </button>
                    </div>
                    {eventFormData.eventStatus === 'Draft' ?
                        (
                            <div className="col-md-8 text-end">
                                {((eventFormData.eventStatus === 'Draft') || (eventFormData.eventStatus === 'Under review')) && (
                                <button
                                    type="button"
                                    id="deleteDraft"
                                    className="btn btn-outline-light right-buttons footerButtons"
                                    onClick={handleDeleteDraft}
                                >
                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6.7377 2.56289C6.66895 1.94414 6.15332 1.46289 5.5002 1.46289C4.84707 1.46289 4.33145 1.94414 4.2627 2.56289L1.68457 2.56289L1.68457 3.31914H2.44082L2.44082 10.1941C2.44082 10.4004 2.6127 10.5723 2.81895 10.5723L8.18145 10.5723C8.3877 10.5723 8.55957 10.4004 8.55957 10.1941L8.55957 3.31914L9.31582 3.31914V2.56289L6.7377 2.56289ZM5.5002 2.15039C5.74082 2.15039 5.98145 2.32227 6.0502 2.56289L4.98457 2.56289C5.01895 2.32227 5.25957 2.15039 5.5002 2.15039ZM7.80332 9.81602L3.19707 9.81602L3.19707 3.31914L7.76895 3.31914L7.76895 9.81602H7.80332Z" fill="white" />
                                        <path d="M5.12148 4.0752H4.36523L4.36523 9.0252H5.12148L5.12148 4.0752Z" fill="white" />
                                        <path d="M6.63418 4.0752H5.87793L5.87793 9.0252H6.63418L6.63418 4.0752Z" fill="white" />
                                    </svg>
                                    <span>DELETE DRAFT</span>
                                </button>
                                )}
                                <button
                                    id="saveChanges"
                                    className="btn btn-outline-light right-buttons footerButtons"
                                    onClick={handleSubmit}
                                >
                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M1.83254 1.53125L1.83254 7.63341L9.16746 7.63341L9.16746 3.45388L8.04612 2.33254H6.57866L6.57866 4.36659L2.72629 4.36659L2.72629 2.33254H1.83254L1.83254 1.53125ZM1.83254 1.53125L8.37802 1.53125L9.96875 3.12198L9.96875 9.66746C9.96875 10.11 9.61 10.4688 9.16746 10.4688L1.83254 10.4688C1.39 10.4688 1.03125 10.11 1.03125 9.66746L1.03125 2.33254C1.03125 1.89 1.39 1.53125 1.83254 1.53125ZM3.52759 2.33254L3.52759 3.5653L5.77737 3.5653V2.33254L3.52759 2.33254ZM9.16746 8.4347H1.83254L1.83254 9.66746L9.16746 9.66746V8.4347Z" fill="white" />
                                    </svg>
                                    <span> SAVE CHANGES</span>
                                </button>

                                <button
                                    type="button"
                                    id="sendValidation"
                                    className="buttonrequest btn btn-outline-light right-buttons footerButtons"
                                    onClick={handleSendForValidation}
                                >
                                    <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1.16523 3.72227L0.615234 4.27227L2.16211 5.81914C2.33398 5.99102 2.64336 5.99102 2.84961 5.81914L8.31524 0.353516L7.24961 0.353516L2.54023 5.06289L1.16523 3.72227Z" fill="currentColor" />
                                    </svg>
                                    <span>SEND FOR VALIDATION</span>
                                </button>
                            </div>
                        ) :
                        (
                            <div className="col-md-8 text-end">
                                <>
                                    {eventFormData.eventStatus !== "Attendance confirmed" && (
                                    <button
                                        id="rejectEvent"
                                        type="button"
                                        className="btn btn-outline-light right-buttons footerButtons footerButtonsMarsf"
                                        onClick={handleRejectClick}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x" viewBox="0 0 16 16">
                                            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 1 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                                        </svg>
                                        <span>DECLINE INVITATION</span>
                                    </button>
                                    )}
                                    <ConfirmationModal
                                        isOpen={isModalOpen}
                                        onClose={() => setIsModalOpen(false)}
                                        onSave={handleSaveClick}
                                        onCancel={handleCancelClick}
                                    />
                                    {eventFormData.eventStatus !== "Attendance confirmed" && (
                                    <button type="button" id="ReturnToRequestor" className="btn btn-outline-light right-buttons footerButtons footerButtonsMarsf"
                                        onClick={handleTentativeClick}>
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="white">
                                            <path d="M12 22a10 10 0 1110-10 10.011 10.011 0 01-10 10zm0-18a8 8 0 108 8 8.009 8.009 0 00-8-8zm4 9h-5a1 1 0 01-1-1V7a1 1 0 112 0v4h4a1 1 0 010 2z" />
                                        </svg>
                                        <span>TENTATIVE</span>
                                    </button>
                                    )}
                                    <ConfirmationModalTentative
                                        isOpen={isTentativeModalOpen}
                                        onClose={() => setIsTentativeModalOpen(false)}
                                        onSave={handleTentativeSaveClick}
                                        onCancel={handleTentativeCancelClick}
                                    />
                                    {eventFormData.eventStatus !== "Attendance confirmed" && (
                                        <button
                                            type="button"
                                            id="ValidateOpen"
                                            className="buttonrequest btn btn-outline-light right-buttons footerButtons footerButtonsMarsf"
                                            onClick={handleAcceptClick}
                                        >
                                            <svg
                                                width="18"
                                                height="12"
                                                viewBox="0 0 18 12"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M1.16523 3.72227L0.615234 4.27227L2.16211 5.81914C2.33398 5.99102 2.64336 5.99102 2.84961 5.81914L8.31524 0.353516L7.24961 0.353516L2.54023 5.06289L1.16523 3.72227Z"
                                                    fill="currentColor"
                                                />
                                            </svg>
                                            <span>ACCEPT INVITATION</span>
                                        </button>
                                    )}
                                    <ConfirmationModalAccept
                                        isOpen={isAcceptModalOpen}
                                        onClose={() => setIsAcceptModalOpen(false)}
                                        onSave={handleAcceptSaveClick}
                                        onCancel={handleAcceptCancelClick}
                                    />
                                </>
                            </div>
                        )
                    }
                </div>
            </div>
        </footer>
    );
}